import React, { useState, useEffect } from "react";
import { Button } from "antd";
import { MinusOutlined, ExpandOutlined, CloseOutlined, CustomerServiceOutlined } from "@ant-design/icons";
import "./CTIFrame.less";

function CTIFrame({ ctiUrl, onClose }) {
  const [minimized, setMinimized] = useState(() => {
    const savedState = localStorage.getItem("cti_minimized");
    return savedState === "true";
  });
  const [position, setPosition] = useState(() => {
    const savedPosition = localStorage.getItem("cti_position");
    return savedPosition ? JSON.parse(savedPosition) : { x: window.innerWidth - 420, y: window.innerHeight - 620 };
  });
  const [dragging, setDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (dragging) {
        const newPosition = {
          x: e.clientX - dragOffset.x,
          y: e.clientY - dragOffset.y,
        };
        setPosition(newPosition);
      }
    };

    const handleMouseUp = () => {
      setDragging(false);
      // Save position when dragging stops
      localStorage.setItem("cti_position", JSON.stringify(position));
    };

    if (dragging) {
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    }

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [dragging, dragOffset, position]);

  const handleMouseDown = (e) => {
    if (!minimized && e.target.closest(".cti-frame-header") && !e.target.closest(".cti-frame-controls")) {
      setDragging(true);
      setDragOffset({
        x: e.clientX - position.x,
        y: e.clientY - position.y,
      });
    }
  };

  const toggleMinimize = () => {
    const newMinimizedState = !minimized;
    setMinimized(newMinimizedState);
    localStorage.setItem("cti_minimized", newMinimizedState.toString());
  };

  return (
    <div
      className={`cti-frame-container ${minimized ? "minimized" : ""}`}
      style={!minimized ? {
        left: position.x,
        top: position.y,
      } : {}}
    >
      <div
        className="cti-frame-header"
        onMouseDown={handleMouseDown}
        onClick={minimized ? toggleMinimize : undefined}
      >
        <span className="cti-frame-title">
          {minimized && <CustomerServiceOutlined className="cti-icon" />}
          CTI Tool
        </span>
        <div className="cti-frame-controls">
          {!minimized && (
            <Button
              type="text"
              size="small"
              icon={<MinusOutlined />}
              onClick={toggleMinimize}
              className="cti-control-btn cti-minimize-btn"
            />
          )}
          {/* <Button
            type="text"
            size="small"
            icon={<CloseOutlined />}
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            className="cti-control-btn cti-close-btn"
          /> */}
        </div>
      </div>
      {!minimized && (
        <div className="cti-frame-body">
          <iframe
            src={ctiUrl}
            title="CTI Tool"
            className="cti-iframe"
            frameBorder="0"
            allow="microphone; camera"
          />
        </div>
      )}
    </div>
  );
}

export default CTIFrame;
